import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpClientWrapper } from '@fc-core/services/http-wrapper';
import { BackendResponse } from '@fc-core/models/response.model';
import { QuickSearchApiItem } from '@fc-search/models/quick-search';
import { environment } from 'src/environments/environment';
import { AdvancedSearchResult, SearchParams } from '@fc-search/models/search';

@Injectable({
  providedIn: 'root',
})
export class SearchApiService {
  private http = inject(HttpClientWrapper);

  getSearchResults(
    query: string,
    params: SearchParams,
  ): Promise<BackendResponse<AdvancedSearchResult[]>> {
    let httpParams = new HttpParams().set('q', query);
    if (params.createdGte)
      httpParams = httpParams.set('created__gte', params.createdGte);
    if (params.createdLte)
      httpParams = httpParams.set('created__lte', params.createdLte);
    if (params.createdBy)
      httpParams = httpParams.set('created_by', params.createdBy);
    if (params.entityType)
      httpParams = httpParams.set('entity_type', params.entityType);
    if (params.entityTypeIn)
      httpParams = httpParams.set(
        'entity_type__in',
        params.entityTypeIn.join(','),
      );
    if (params.archived !== undefined)
      httpParams = httpParams.set('archived', params.archived.toString());
    if (params.limit)
      httpParams = httpParams.set('limit', params.limit.toString());
    if (params.modifiedGte)
      httpParams = httpParams.set('modified__gte', params.modifiedGte);
    if (params.modifiedLte)
      httpParams = httpParams.set('modified__lte', params.modifiedLte);
    if (params.offset)
      httpParams = httpParams.set('offset', params.offset.toString());
    if (params.ordering)
      httpParams = httpParams.set('ordering', params.ordering);
    if (params.employee)
      httpParams = httpParams.set('employee', params.employee);
    if (params.group != null)
      httpParams = httpParams.set('group', params.group.toString());

    return this.http.get(
      `${environment.apiUrl}api/search/advanced`,
      httpParams,
    );
  }

  getQuickSearchResults(
    query: string,
    type: string = 'all',
  ): Promise<QuickSearchApiItem[]> {
    const httpParams = new HttpParams().set('q', query).set('type', type);

    return this.http.get(`${environment.apiUrl}api/search/quick/`, httpParams);
  }

  getRecentQuickSearchItems(limit: number): Promise<QuickSearchApiItem[]> {
    const httpParams = new HttpParams().set('limit', limit.toString());

    return this.http.get(
      `${environment.apiUrl}api/search/quick/recent/`,
      httpParams,
    );
  }

  quickSearchEntityOpened(entityType: string, objectId: string): Promise<void> {
    return this.http.post(`${environment.apiUrl}api/search/quick/select/`, {
      entity_type: entityType,
      entity_id: objectId,
    });
  }
}
